{
    "private": false,
    "name": "priva-analytics-building",
    "version": "1.1.5-rc3",
    "description": "Priva Analytics",
    "license": "MIT",
    "repository": {
        "type": "GIT",
        "url": ""
    },
    "engines": {
        "node": "^24",
        "pnpm": "^11"
    },
    "devEngines": {
        "runtime": {
            "name": "node",
            "version": "24.20.0",
            "onFail": "error"
        },
        "packageManager": {
            "name": "pnpm",
            "version": "11.25.0",
            "onFail": "download"
        }
    },
    "scripts": {
        "prepare": "cd ../.. && husky",
        "prestart": "pnpm localize",
        "start": "run-p -r start:server start:proxy",
        "start:debug": "ng serve --open --watch --ec --sm",
        "start:proxy": "ng serve --open --watch --proxy-config proxy.conf.json",
        "start:server": "node mock-server/server",
        "start:withpackages": "pnpm start:proxy -- --app packages --aot",
        "start:bff": "dotnet run --project ../Server/Priva.Analytics.Building.Web --launch-profile FTR1",
        "prebuild": "pnpm localize",
        "build": "ng build --configuration production",
        "build:dev": "ng build",
        "build:test": "ng build --configuration test",
        "prebuild:watch": "pnpm localize",
        "build:watch": "ng build --configuration test --watch --delete-output-path=false",
        "build:web": "ng build --configuration production --optimization=false --output-path ../Server/Priva.Analytics.Building.Web/Web",
        "localize": "localization-cli --sourcePaths localization/source -d src/assets/translations",
        "test": "pnpm test:jest:watch",
        "test:single": "pnpm test:jest",
        "debug:test": "ng test --debug",
        "test:jest": "jest --coverage --maxWorkers=50%",
        "test:jest:minimal": "jest --verbose=false --silent --noStackTrace --maxWorkers=50% --passWithNoTests",
        "test:jest:watch": "jest --coverage --maxWorkers=25% --watchAll",
        "e2e-tests": "pnpm exec ts-node e2e-tests/setup/set-env-playwright-launch.ts",
        "e2e-debug": "pnpm exec ts-node e2e-tests/setup/set-env-playwright-launch.ts --ui",
        "lint": "pnpm lint:check",
        "lint:check": "run-p lint:check:*",
        "lint:check:scripts": "eslint . --cache",
        "lint:check:styles": "stylelint **/*.{css,scss} --cache",
        "lint:check:format": "prettier --check . --ignore-unknown --log-level warn",
        "lint:fix": "run-p lint:fix:*",
        "lint:fix:scripts": "eslint . --fix --cache",
        "lint:fix:styles": "stylelint --fix **/*.{css,scss} --cache",
        "lint:fix:format": "prettier --write . --ignore-unknown --log-level warn",
        "swagger-typescript-generate": "pnpm exec swagger-typescript-api --union-enums --no-client -p  './src/app/models/swagger.json' -o ./src/app/models -n api-dto.model.ts",
        "all-tasks": "pnpm lint:fix && pnpm lint && pnpm test:jest && pnpm test:single && pnpm build"
    },
    "prettier": "@priva/linter/prettier-config",
    "dependencies": {
        "@angular/animations": "^22.2.0",
        "@angular/cdk": "^22.2.0",
        "@angular/common": "^22.2.0",
        "@angular/compiler": "^22.2.0",
        "@angular/core": "^22.2.0",
        "@angular/forms": "^22.2.0",
        "@angular/platform-browser": "^22.2.0",
        "@angular/router": "^22.2.0",
        "@ng-select/ng-select": "^23.11.0",
        "@ngrx-toolkit/core": "^22.0.1",
        "@ngrx/effects": "^22.0.0",
        "@ngrx/operators": "^22.0.0",
        "@ngrx/router-store": "^22.0.0",
        "@ngrx/signals": "^22.0.0",
        "@ngrx/store": "^22.0.0",
        "@ngrx/store-devtools": "^22.0.0",
        "@ngx-translate/core": "^18.0.0",
        "@popperjs/core": "^2.11.8",
        "@priva/analytics": "^17",
        "@priva/apps": "^4",
        "@priva/appshell": "^32",
        "@priva/auth": "^19",
        "@priva/charts": "^31",
        "@priva/components": "^59",
        "@priva/error-pages": "^20",
        "@priva/localization": "^22",
        "@priva/notifications": "^5",
        "@priva/preferences": "^4",
        "@priva/preloader": "^2.0.0",
        "@priva/styles": "^43",
        "@priva/utilities": "^17",
        "@segment/analytics-next": "^1.84.0",
        "angular-oauth2-oidc": "^20.0.2",
        "axios": "^1.20.0",
        "core-js": "^3.49.0",
        "d3": "^7.9.0",
        "dayjs": "1.11.9",
        "deepmerge-ts": "^7.1.5",
        "highcharts": "^11.4.8",
        "highcharts-angular": "^4.0.1",
        "lodash": "^4.18.1",
        "ng2-date-picker": "^22.0.0",
        "ngx-cookie": "^6.0.1",
        "ngx-segment-analytics": "^19.0.1",
        "ngx-window-token": "^7.0.0",
        "rxjs": "^7.8.2",
        "tslib": "^2.8.1",
        "zone.js": "~0.16.2"
    },
    "devDependencies": {
        "@angular/build": "^22.2.0",
        "@angular/cli": "^22.2.0",
        "@angular/compiler-cli": "^22.2.0",
        "@angular/language-service": "^22.2.0",
        "@azure/keyvault-secrets": "^4.11.2",
        "@playwright/test": "^1.60.0",
        "@priva/apitestframework": "^2.4.2",
        "@priva/linter": "14.0.0",
        "@priva/localization-cli": "^5.6.1",
        "@types/d3": "^7.4.3",
        "@types/jasmine": "~6.0.0",
        "@types/jest": "^30.0.0",
        "@types/lodash": "4.17.24",
        "@types/luxon": "^3.7.1",
        "@types/mocha": "^10.0.10",
        "@types/node": "^24.12.2",
        "async": "3.2.6",
        "body-parser": "^2.2.2",
        "chalk": "^5.6.2",
        "chokidar": "^5.0.0",
        "cli-spinner": "^0.2.10",
        "copyfiles": "2.4.1",
        "cors": "2.8.6",
        "cross-env": "^10.1.0",
        "env-cmd": "^11.0.0",
        "eslint": "^10.11.0",
        "express": "5.2.1",
        "express-jwt": "8.5.1",
        "fs-extra": "11.3.5",
        "handlebars": "^4.7.9",
        "husky": "^9.1.7",
        "jest": "^30.4.2",
        "jest-environment-jsdom": "^30.4.1",
        "jest-jasmine2": "^30.4.2",
        "jest-junit": "^17.0.0",
        "jest-preset-angular": "^17.0.0",
        "json": "11.0.0",
        "jsonfile": "6.2.1",
        "jsonwebtoken": "^9.0.3",
        "junit-report-merger": "^9.0.3",
        "lint-staged": "^16.4.0",
        "log4js": "^6.9.1",
        "luxon": "^3.7.2",
        "mocha-junit-reporter": "^2.2.1",
        "ng-mocks": "^14.18.1",
        "ngx-spec": "^2.1.6",
        "npm-run-all": "^4.1.5",
        "postcss": "^8.5.14",
        "postcss-scss": "^4.0.9",
        "prettier": "^3.8.3",
        "puppeteer": "^24.43.1",
        "recursive-search": "1.0.1",
        "sass": "~1.100.0",
        "stylelint": "^17.12.0",
        "swagger-typescript-api": "^13.12.2",
        "ts-jest": "^29.4.11",
        "ts-mocks": "^3.0.1",
        "ts-node": "^10.9.2",
        "typedoc": "^0.28.19",
        "typescript": "~6.0.0",
        "update-json-file": "1.1.1",
        "uuid": "^14.0.0",
        "yargs": "18.0.0"
    }
}
